import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, Type, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from "@angular/router";
import moment from "moment";
import { Subscription } from "rxjs";
import { ClosedLoop } from "src/app/modules/pages/interview-summary/models/closed-loop";
import { InterviewSummary } from "src/app/modules/pages/interview-summary/models/interview-summary";
import { MyUtils } from "src/app/services/my-utils.service";
import { SurveyService } from "src/app/services/survey.service";
import { HotAlert } from "../../../modules/pages/hot-alert/configurations/hot-alert";
import { ApplicationService } from "../../../services/application.service";
import { InterviewsService } from "../../../services/interviews.service";
import { DownloadExcelCommand } from "../../commands/download-excel-command";
import { ActionCol } from "../../table-col-configs/action-col";
import { ActionButtonsComponent } from "../../table-components/action-buttons/action-buttons.component";
import { InterviewDetail } from "./models/interview-details";
import { DownloadPDFCommand } from "../../commands/download-pdf-command";
import { Appeal } from "src/app/modules/pages/hot-alert/configurations/appeal";
import { LoaderService } from "src/app/services/loader.service";
import { TableStructure } from "src/app/modules/records/models/table-structure";

export interface InterviewData {
  brand: string;
  region: string;
  surveyId: string;
  surveyDate: string;
}

@Component({
  selector: "app-table-links-modal",
  templateUrl: "./table-links-modal.component.html",
  styleUrls: ["./table-links-modal.component.scss"],
})
export class TableLinksModalComponent implements OnInit, OnDestroy {

  tableConfig: TableStructure<any> = new TableStructure<any>([], "clientSide");
  @ViewChild(ActionButtonsComponent)
  actionButtonsComponent?: ActionButtonsComponent<InterviewDetail>;

  singleAppeal!: Appeal;
  clientDetails = new InterviewDetail();
  subscription?: Subscription;
  expandAppeal: boolean = false;

  isAppel = false;

  showInterview: boolean = false;

  allQuestions: InterviewDetail[] = [];

  tableData: { answer: string; question: string }[] = [];

  actions: DownloadExcelCommand<InterviewDetail, SurveyService>[];

  constructor(

    private cdr: ChangeDetectorRef,
    private surveyService: SurveyService,
    private interviewService: InterviewsService,
    public utils: MyUtils,
    private applicationService: ApplicationService,
    @Inject(MAT_DIALOG_DATA) public interviewData: InterviewSummary | HotAlert | ClosedLoop,
    public router: Router,
    private loader: LoaderService,
    public dialogRef?: MatDialogRef<TableLinksModalComponent>

  ) {
    this.actions = [new DownloadExcelCommand(this.surveyService)];
  }

  ngOnInit(): void {
    if (this.router?.url === "/interviewSummary/interview-summary-elastic") {
      this.getInterviewDetailsElastic();
    } else {
      this.getInterviewDetails();
    }

  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }


  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }

  getInterviewDetails() {
    this.subscription = this.surveyService
      .getInterviewDetails(
        this.interviewData.brand,
        this.interviewData.region,
        this.applicationService.navBarSelectValue.idItem,
        this.interviewData.surveyRequestId,
        this.interviewData.dataSurvey as string,
      )
      .subscribe((response) => {
        let resp = JSON.parse(response);

        if (resp && resp.success) {
          const data: Array<InterviewDetail> = resp.data.data
          let ids = this.interviewService.idTableValue ? this.interviewService.idTableValue : [];
          this.clientDetails = data[0];
          ids.push(this.clientDetails.surveyRequestId);
          this.interviewService.setIdsTableValue(ids);

          this.allQuestions = (data as Array<InterviewDetail>)
            .slice(1)
            .map((q) => new InterviewDetail(q));

          this.clientDetails.caseCloseDate = moment(this.clientDetails.caseCloseDate).format(
            "DD/MM/YYYY"
          );
          this.clientDetails.caseOpenDate = moment(this.clientDetails.caseOpenDate).format(
            "DD/MM/YYYY"
          );

          resp.data.data.shift();


          this.actionButtonsComponent?.setComponentData(
            this.clientDetails,
            new ActionCol<InterviewDetail, Type<ActionButtonsComponent<InterviewDetail>>, any>(
              "surveyRequestId",
              false,
              undefined,
              [new DownloadExcelCommand<InterviewDetail, SurveyService>(this.surveyService), new DownloadPDFCommand<InterviewDetail, SurveyService>(this.surveyService)],
              ActionButtonsComponent
            )
          );
        }
      });
  }

  getInterviewDetailsElastic() {
    this.subscription = this.surveyService
      .getInterviewDetailsElastic(
        this.interviewData.brand,
        this.interviewData.region,
        this.applicationService.navBarSelectValue.idItem,
        this.interviewData.surveyRequestId,
        this.interviewData.interviewdate as string,
      )
      .subscribe((response) => {
        let resp = JSON.parse(response);

        if (resp && resp.success) {
          const data: Array<InterviewDetail> = resp.data.data
          let ids = this.interviewService.idTableValue ? this.interviewService.idTableValue : [];
          //data[0].completedDate = moment(data[0].responseDate).format("DD/MM/YYYY");
          this.clientDetails = data[0];
          ids.push(this.clientDetails.surveyRequestId);
          this.interviewService.setIdsTableValue(ids);

          this.allQuestions = (data as Array<InterviewDetail>)
            .slice(1)
            .map((q) => new InterviewDetail(q));

          this.clientDetails.completedDateTime = moment(
            this.clientDetails.completedDateTime, "DD/MM/YYYY"
          ).format("DD/MM/YYYY");
          this.clientDetails.responseDate = moment(this.clientDetails.responseDate, "DD/MM/YYYY").format(
            "DD/MM/YYYY"
          );
          this.clientDetails.caseCloseDate = moment(this.clientDetails.caseCloseDate, "DD/MM/YYYY").format(
            "DD/MM/YYYY"
          );
          this.clientDetails.caseOpenDate = moment(this.clientDetails.caseOpenDate, "DD/MM/YYYY").format(
            "DD/MM/YYYY"
          );
          this.clientDetails.eventDate = moment(this.clientDetails.eventDate, "DD/MM/YYYY").format("DD/MM/YYYY");
          resp.data.data.shift();

          this.actionButtonsComponent?.setComponentData(
            this.clientDetails,
            new ActionCol<InterviewDetail, Type<ActionButtonsComponent<InterviewDetail>>, any>(
              "surveyRequestId",
              false,
              undefined,
              [new DownloadExcelCommand<InterviewDetail, SurveyService>(this.surveyService, true), new DownloadPDFCommand<InterviewDetail, SurveyService>(this.surveyService)],
              ActionButtonsComponent
            )
          );
        }
      });
  }


  clickShowInterview() {
    this.showInterview = !this.showInterview;
  }

}
